"use strict";

const R = require('ramda');

/**
 * Element builder
 * @module
 * @param {Array} rules - array of rules
 * @param {Object} data - json data
 * @param {Object} fields - map of fields
 **/

module.exports = (rules, data, fields = {}) => rules.reduce(rule(json(data), fields), {});
const json = d => trim(d.constructor === Object ? d : JSON.parse(d)),
  trim = d => Object.keys(d).reduce((d, k) => {
    if (typeof d[k] === 'string') d[k] = d[k].trim();else if (d[k] && d[k].constructor === Object) trim(d[k]);
    return d;
  }, d),
  rule = (d, F) => (e, r) => r.fields.filter(f => !d.__fields || d.__fields.includes(f)).reduce(validators(r, d, F), e),
  validators = (r, d, F) => (e, f) => [...((r.required && r.required.constructor === Function ? r.required(d, f, r) : r.required) ? [isNotEmpty] : []), ...((isNotEmpty(value(d, F, f)) ? r.validators : []) || [])].reduce(validator(r, d, F, f), e),
  validator = (r, d, F, f) => (e, v) => {
    const val = value(d, F, f);
    return (r.required && r.required.constructor === Function ? r.required(d, f, r) : r.required) || v.constructor === Function || val !== undefined ? type(v)(val, f, d, r) ? e : error(e, r, f) : e;
  },
  value = (d, F, f) => F.hasOwnProperty(f) ? R.path(F[f], d) : d[f],
  error = (e, r, f) => ({
    ...e,
    [f]: e[f] ? (e[f].includes(r.name) || e[f].push(r.name)) && e[f] : [r.name]
  }),
  type = f => (({
    isArray,
    isRegExp,
    isFunction
  })[`is${f.constructor.name}`] || isString)(f),
  isNotEmpty = v => !['', undefined, null, NaN].includes(v),
  isArray = a => v => a.filter(a => `${a}` === `${v}`).length,
  isString = s => isArray([s]),
  isRegExp = r => v => r.test(v),
  isFunction = f => f;
